import { applyFilters, getFilterObject } from '../../_global/js/search/apply_filters';

(function () {
    /**
     * The Events Search
     * 
     * @module eventSearch
     */

    /**
     * Check if the event search class is present on the page
     */
     function isEventSearchPage() {
        return document.querySelector('.event-search') !== null;
    }

    if (isEventSearchPage()) {

        console.log("isEventSearchPage")

        var eventSearch = {};
        var windowWidth = window.innerWidth;

        // Object to store current filter states
        var currentEventFilterStates = {};

        /**
         * Initialise the Event Search listeners for keyboard navigation
         * 
         * @memberof module:eventSearch
         */
        eventSearch.init = function() { 
            if (document.querySelector('.qld__search__facet-list')) {
                setMobileView();
    
                window.addEventListener('resize', debounce(checkWindowResize, 100));
                var facetInputs = document.querySelectorAll('.qld__search__facet-list .qld__search__facet-input');

                // Listen for changes on facet inputs, but only update the state object
                for (var i = 0; i < facetInputs.length; i++) {
                    facetInputs[i].addEventListener('change', function () {
                        const filterQuery = this.dataset.querystring;
                        currentEventFilterStates[filterQuery] = this.checked;
                        console.log("currentEventFilterStates -->", currentEventFilterStates);
                    });

                    // Add keydown event to handle Enter key for keyboard navigation
                    facetInputs[i].addEventListener('keydown', function (event) {
                        if (event.key === 'Enter') {
                            this.checked = !this.checked; // Toggle checkbox state
                            this.dispatchEvent(new Event('change')); // Trigger change event
                        }
                    });
                }


                // Get date range picker values from parent classes
                const dateStartInput = document.querySelector('.qld__date-picker-one duet-date-picker');
                const dateEndInput = document.querySelector('.qld__date-picker-two duet-date-picker');

                // Helper function to format input as dd/mm/yyyy and update date values
                // function formatInput(event, isStartDate) {
                //     let input = event.target.value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                    
                //     // Format the input into MM/DD/YYYY
                //     if (input.length >= 2) input = input.slice(0, 2) + '/' + input.slice(2);
                //     if (input.length >= 5) input = input.slice(0, 5) + '/' + input.slice(5);
                    
                //     // Restrict to a maximum of 10 characters (MM/DD/YYYY)
                //     event.target.value = input.slice(0, 10);
                    
                //     // Update the corresponding date value based on the input type
                //     if (isStartDate) {
                //         dateStartValue = event.target.value; // Update start date value
                //     } else {
                //         dateEndValue = event.target.value; // Update end date value
                //     }
                // }

                function formatInput(event, isStartDate) {
                    console.log("just by typing");
                
                    // Get the raw input without any non-numeric characters (and remove slashes)
                    let input = event.target.value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                
                    // Check if the length is 8 (which is the total length for dd/mm/yyyy)
                    if (input.length >= 2) {
                        // Convert dd to yyyy
                        const day = input.slice(0, 2); // First two digits are the day
                        const month = input.slice(2, 4); // Next two digits are the month
                        const year = input.slice(4, 8); // Last four digits are the year
                
                        // Format it as yyyy-mm-dd
                        if (month.length === 2 && day.length === 2 && year.length === 4) {
                            input = `${year}-${month}-${day}`; // yyyy-mm-dd format
                        } else {
                            // If the input is incomplete, keep it as dd/mm/yyyy format
                            if (input.length >= 2) input = input.slice(0, 2) + '/' + input.slice(2);
                            if (input.length >= 5) input = input.slice(0, 5) + '/' + input.slice(5);
                        }
                    }
                
                    // Restrict the length to a maximum of 10 characters (yyyy-mm-dd)
                    event.target.value = input.slice(0, 10);
                
                    // Update the corresponding date value based on the input type
                    if (isStartDate) {
                        dateStartValue = event.target.value; // Update start date value
                    } else {
                        dateEndValue = event.target.value; // Update end date value
                    }
                
                    // Check if the date is valid
                    const isStartDateValid = isValidDate(dateStartValue);
                    const isEndDateValid = isValidDate(dateEndValue);
                
                    // If the date is invalid, display the error message for the corresponding input
                    const errorElementOne = document.querySelector('.qld__events__search .qld__date-picker__error');
                    const errorElementTwo = document.querySelector('.qld__events__search .qld__date-picker-two__error');
                
                    if (!isStartDateValid) {
                        errorElementOne.style.display = 'block';
                    } else {
                        errorElementOne.style.display = 'none'; // Hide error when start date is corrected
                    }
                
                    // Display error for the end date if it's invalid
                    if (!isEndDateValid) {
                        errorElementTwo.style.display = 'block';
                    } else {
                        errorElementTwo.style.display = 'none'; // Hide error when end date is corrected
                    }
                }
                
                // Function to validate date components
                function isValidDate(dateString) {
                    // Handle date in yyyy-mm-dd format
                    const date = new Date(dateString);
                    return !isNaN(date.getTime()); // Returns true if it's a valid date, false if invalid
                }
                
                // Add input listeners to enforce the format and update date values
                if (dateStartInput) {
                    dateStartInput.addEventListener('input', (event) => formatInput(event, true));
                }
                if (dateEndInput) {
                    dateEndInput.addEventListener('input', (event) => formatInput(event, false));
                }
                
                // Variables to store date values
                let dateStartValue = null;
                let dateEndValue = null;
                
                // Event listener to capture date changes
                if (dateStartInput) {
                    dateStartInput.addEventListener('duetChange', (event) => {
                        dateStartValue = event.detail.valueAsDate;
                        console.log("dateStartValue", dateStartValue)
                    });
                }
                
                if (dateEndInput) {
                    dateEndInput.addEventListener('duetChange', (event) => {
                        dateEndValue = event.detail.value;
                        console.log("dateEndValue", dateEndValue)
                    });
                }
                
                // Add event listener to the apply filters button
                const applyFiltersButton = document.querySelector('.qld__btn.qld__apply-filters__btn');
                if (applyFiltersButton) {
                    applyFiltersButton.addEventListener('click', function (e) {

                        // Check if any error message is currently visible
                        const errorElementOne = document.querySelector('.qld__events__search .qld__date-picker__error');
                        const errorElementTwo = document.querySelector('.qld__events__search .qld__date-picker-two__error');

                        // If any error message is visible, prevent the default action (e.g., form submission)
                        if ((errorElementOne && errorElementOne.style.display === 'block') || 
                            (errorElementTwo && errorElementTwo.style.display === 'block')) {
                            e.preventDefault();  // Prevent filter submission
                            console.log("Form submission prevented due to invalid dates");
                            return

                        } else {
                            // Dynamically get date values from the inputs
                            const dateStartInput = document.querySelector('.qld__date-picker-one duet-date-picker');
                            const dateEndInput = document.querySelector('.qld__date-picker-two duet-date-picker');
                            const dateStartValue = dateStartInput.value
                            const dateEndValue = dateEndInput.value

                            // Validate date range if both dates are entered
                            if (dateStartValue && dateEndValue) {
                                // Check if the date format is valid
                                if (!isValidDate(dateStartValue) || !isValidDate(dateEndValue)) {
                                    alert("Please enter valid dates in MM/DD/YYYY format.");
                                    return;
                                }

                                // Check if the start date is later than the end date
                                if (new Date(dateStartValue) > new Date(dateEndValue)) {
                                    console.log("dateStartValue > dateEndValue")
                                    errorElementOne.style.display='block'
                                    errorElementOne.innerHTML="Start date value cannot be higher than End date Value."
                                    return;
                                }
                            } 

                            // Get filters dynamically from the DOM
                            const facetLists = document.querySelectorAll('.qld__search__facet-list');
                            let allCurrentFilters = [];

                            facetLists.forEach((facetList) => {
                                const currentFilters = getFilterObject(facetList);
                                allCurrentFilters = allCurrentFilters.concat(currentFilters);
                            });

                            // Add date filters if they have values
                            if (dateStartValue) {
                                allCurrentFilters.push({ dateStart: dateStartValue });
                            }
                            if (dateEndValue) {
                                allCurrentFilters.push({ dateEnd: dateEndValue });
                            }

                            console.log("FINAL: ", allCurrentFilters);

                            // Apply the filters
                            applyFilters(allCurrentFilters);
                        }
                    });
                }


                // Select all toggle buttons for the facet lists
                var toggleButtons = document.querySelectorAll('.qld__search__facet-button.qld__search__facet-button--toggle');
                if (toggleButtons.length) { // Check if any buttons were found
                    initializeFacetListToggleButtons(toggleButtons);
                }

                // Select all buttons with class 'qld__link' and 'qld__search__filter-tag--clear'
                var clearFilterTagButtons = document.querySelectorAll('.qld__link.qld__search__filter-tag--clear');

                if (clearFilterTagButtons.length) {
                    // Function to clear all filters and reload page without query parameters
                    const clearFilters = () => {
                        // Redirect to the page without any query parameters
                        window.location.href = `${window.location.origin}${window.location.pathname}`;
                    };

                    // Attach event listeners to each 'clear all' button
                    clearFilterTagButtons.forEach(button => {
                        button.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') {
                                clearFilters();
                            }
                        });

                        button.addEventListener('click', (e) => {
                            clearFilters();
                        });
                    });
                }

            };
        }

        function initializeFacetListToggleButtons(toggleButtons) {
            for (var i = 0; i < toggleButtons.length; i++) {
                (function(button) {
                    var facetList = button.closest('.qld__search__facet-list');
                    var listItems = facetList.querySelectorAll('li');
        
                    // Initially hide items beyond the 8th
                    hideAdditionalFacetListItems(listItems);
        
                    button.addEventListener('click', function() {
                        toggleFacetListItems(button, listItems);
                    });
                })(toggleButtons[i]);
            }
        }

        function hideAdditionalFacetListItems(listItems) {
            if (listItems.length > 8) {
                for (var i = 8; i < listItems.length; i++) {
                    listItems[i].classList.add('hidden');
                }
            }
        }

        function toggleFacetListItems(button, listItems) {
            var isShowingAll = button.classList.contains('showing-all');
        
            if (isShowingAll) {
                // Currently showing all items - hide extras and update button
                for (var i = 8; i < listItems.length; i++) {
                    listItems[i].classList.add('hidden');
                }
                button.textContent = 'Show all';
                button.classList.remove('qld__search__facet-button--hide');
                button.classList.add('qld__search__facet-button--show');
            } else {
                // Currently showing less items - show all and update button
                for (var i = 8; i < listItems.length; i++) {
                    listItems[i].classList.remove('hidden');
                }
                button.textContent = 'Show less';
                button.classList.remove('qld__search__facet-button--show');
                button.classList.add('qld__search__facet-button--hide');
            }
            // Toggle class to reflect current state
            button.classList.toggle('showing-all');
        }

        function updateFilters(filterQuery, state) {  
            var currentQuery = window.location.search.replace('?','').split('&');

            if (state) {
                currentQuery.push(filterQuery);
            }

            currentQuery.forEach(function(query, index) {
                if (query.indexOf('start_rank') > -1) {
                    currentQuery.splice(index, 1);
                }

                if (!state) {
                    if (query === filterQuery) {
                        currentQuery.splice(index, 1);
                    }
                }
            });

            window.location.href = window.location.pathname + '?' + currentQuery.join('&');
        }

        function checkWindowResize() {
            var newWidth = window.innerWidth;

            if (windowWidth > 991 && newWidth < 992) {
                setMobileView();
            }

            windowWidth = newWidth;
        }

        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        function setMobileView() {
            const facetListItems = document.querySelectorAll('.qld__search__facet-list .qld__event__facet-title');

            for (let i = 0; i < facetListItems.length; i++) {
                facetListItems[i].classList.add('qld__event__facet-title--mobile');
            }
        }

        document.addEventListener('DOMContentLoaded', function () {
            eventSearch.init();
        });
    }
}());